import {
  HHInfoGrid,
  HHStack,
  HHTooltip,
  HHTypography,
} from '@hinge-health/react-component-library';
import InfoIcon from '@mui/icons-material/Info';
import { TextareaAutosize } from '@mui/material';
import { useBillingSetting } from '../../context/billing.context';
import { displayDateTime } from '../../utils/date-helper';
import { HoldType } from './bill-grid-components/bill-management-types';

export const InternalHoldDetails = ({ ih }: { ih: HoldType }): JSX.Element => {
  const { value: displayLocal } = useBillingSetting('displayDateTimeLocal');
  return (
    <HHStack
      spacing={1}
      key={ih.holdType}
      bgcolor={(theme): string => theme.palette.background.default}
      padding={2}
      borderRadius={3}
    >
      <HHStack spacing={2} alignItems="center" direction="row">
        <HHTypography
          hhVariant="variant-bypass"
          variant="h5"
          textTransform="capitalize"
        >
          {ih.holdType.replaceAll('_', ' ')}
        </HHTypography>
        {ih.note && (
          <HHTooltip title={ih.note} hhVariant="bottom">
            <InfoIcon color="info" />
          </HHTooltip>
        )}
      </HHStack>
      <HHInfoGrid
        data={[
          {
            content: ih.createdAt
              ? displayDateTime(ih.createdAt, {
                  displayLocal,
                })
              : '--',
            heading: 'Created At',
            copyable: false,
          },
          {
            content: ih.clearedAt
              ? displayDateTime(ih.clearedAt, {
                  displayLocal,
                })
              : '--',
            heading: 'Cleared At',
            copyable: false,
          },
          {
            content: (
              <>
                {ih.details ? (
                  <TextareaAutosize
                    style={{ flex: 1, border: 0 }}
                    defaultValue={JSON.stringify(ih.details)}
                    disabled={true}
                    minRows={1}
                    maxRows={3}
                  />
                ) : (
                  <HHTypography hhVariant="variant-bypass" variant="body1">
                    --
                  </HHTypography>
                )}
              </>
            ),
            heading: 'Details',
            copyable: false,
          },
        ]}
        divided={false}
        justifyBetween={true}
      />
    </HHStack>
  );
};
